import type { DeleteBulkShiftsResponse } from '@libs/data-access/queries'
import { shiftService } from '@libs/data-access/queries'
import type { ReduxState } from '@spa/redux/ReduxState'
import { deleteEntityByIds } from '@spa/scenes/Plannings/redux/reducers'
import { select, put } from 'redux-saga/effects'

import {
  contractsSelectors,
  getParams,
  shiftsSelectors
} from '../../../../selectors'
import fetchPlannablesSideEffectsEntities from '../../../controllers/request/fetchPlannableSideEffectsEntities'
import type { PayloadActionWithoutType } from '../../../types/types'

type Params = PayloadActionWithoutType<
  Partial<{
    contractId: number | null
    day: string
    teamId: number
    weeklyscheduleId: number
    target?: 'cell' | 'row' | 'day' | 'empty'
  }>
>

function* bulkDeleteShifts({ payload }: Params) {
  const params = yield select(getParams)
  const contract: any = yield select((state: ReduxState) =>
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    contractsSelectors.getCachedById(state, payload.contractId)
  )

  const deleteUnassignedShifts =
    !contract && (payload.target === 'cell' || payload.target === 'row')
      ? true
      : undefined

  const res: DeleteBulkShiftsResponse =
    yield shiftService.bulk.api.deleteBulkShifts({
      queryParams: {
        date: payload.day,
        membership_id: contract?.membership_id,
        delete_unassigned_shifts: deleteUnassignedShifts,
        // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
        weeklyschedule_id: payload.weeklyscheduleId
      }
    })

  yield fetchPlannablesSideEffectsEntities({
    contractIds: res.data.resources.map(i => i.contract_id),
    date: params.date,
    countersParams: { live: true }
  })

  const wereUnassignedShiftsDeleted = res.data.resources.find(
    i => i.contract_id === null
  )

  if (wereUnassignedShiftsDeleted) {
    const allShifts = yield select(shiftsSelectors.getCachedMap)
    const shiftsForDay = Object.values(allShifts).filter(
      (shift: any) =>
        (payload.day ? shift.starts_at.startsWith(payload.day) : true) &&
        shift.user_contract_id === null
    )
    yield put(
      deleteEntityByIds({
        entity: 'shifts',
        ids: shiftsForDay.map((shift: any) => shift.id)
      })
    )
  }
}

export default bulkDeleteShifts
